import { Stack, Typography } from "@mui/material";
import { PopupContainer } from "../../components/popup";

export const PolicyPopup = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  if (!visible) return null;

  return (
    <PopupContainer onClose={onClose} title="Cancellation Policy">
      <Stack spacing={2}>
        <Typography variant="body1">
          All memberships with Home Design Guild are
          annual (12-month) contracts. You may cancel the
          membership at any time to cancel the $100 monthly
          platform fee. The $3,500 marketing fee is
          non-refundable. Your full subscription will auto-renew
          in 12 months. Auto-review can be turned off at any
          time.
        </Typography>
        <Typography variant="body1">Why 12 Months?   </Typography>
        <Typography variant="body1">
          Why is the marketing fee non-refundable? We buy
          advertising units and direct mail in advance from
          third-party providers using your marketing fee dollars.
          Those dollars are invested directly to drive
          homeowner leads into your specific territory and are
          non-refundable.  
           {" "}
        </Typography>
        <Typography variant="body1">
          We of course are open to discussing a cancellation in the case of
          hardship or unforeseen circumstances. The cancellation in this case
          would apply to any unpaid fees only.
        </Typography>
      </Stack>
    </PopupContainer>
  );
};
